export const none = 'none'
export const cefr = 'cefr'
export const clb = 'clb'
export const eld = 'eld'
export const nrs = 'nrs'

export const levels = {
  [none]: [
    { label: 'Pre Beg', value: 'Pre Beg' },
    { label: 'Beg', value: 'Beg' },
    { label: 'Low Int', value: 'Low Int' },
    { label: 'Int', value: 'Int' },
    { label: 'High Int', value: 'High Int' },
    { label: 'Adv', value: 'Adv' },
  ],
  [clb]: [
    { label: 'Pre Beg (Pre CLB)', value: 'Pre Beg' },
    { label: 'Beg (CLB 1–2)', value: 'Beg' },
    { label: 'Low Int (CLB 3–4)', value: 'Low Int' },
    { label: 'Int (CLB 5–6)', value: 'Int' },
    { label: 'High Int (CLB 7–9)', value: 'High Int' },
    { label: 'Adv (CLB 10–12)', value: 'Adv' },
  ],
  [cefr]: [
    { label: 'Pre Beg (A0)', value: 'Pre Beg' },
    { label: 'Beg (A1)', value: 'Beg' },
    { label: 'Low Int (A2)', value: 'Low Int' },
    { label: 'Int (B1–B2)', value: 'Int' },
    { label: 'High Int (B2–C1)', value: 'High Int' },
    { label: 'Adv (C1–C2)', value: 'Adv' },
  ],
  [eld]: [
    { label: 'Pre Beg (Pre ELD)', value: 'Pre Beg' },
    { label: 'Beg (ELD 1)', value: 'Beg' },
    { label: 'Low Int (ELD 2)', value: 'Low Int' },
    { label: 'Int (ELD 3-4)', value: 'Int' },
    { label: 'High Int (ELD 5)', value: 'High Int' },
    { label: 'Adv (ELD 6)', value: 'Adv' },
  ],
  [nrs]: [
    { label: 'Pre Beg (NRS 1)', value: 'Pre Beg' },
    { label: 'Beg (NRS 2)', value: 'Beg' },
    { label: 'Low Int (NRS 3)', value: 'Low Int' },
    { label: 'Int (NRS 4-5)', value: 'Int' },
    { label: 'High Int (NRS 5-6)', value: 'High Int' },
    { label: 'Adv (NRS 6+)', value: 'Adv' },
  ],
}
